import { render, staticRenderFns } from "./Container5.vue?vue&type=template&id=5d835860&scoped=true"
import script from "./Container5.vue?vue&type=script&lang=js"
export * from "./Container5.vue?vue&type=script&lang=js"
import style0 from "./Container5.vue?vue&type=style&index=0&id=5d835860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d835860",
  null
  
)

export default component.exports